import { useState } from "react";
import { ChevronDown } from "lucide-react";

// Sezione collassabile condivisa (cliente/pro/admin): intestazione sempre visibile
// con titolo, badge contatore e chevron; contenuto reso solo quando aperta.
// Supporta uso controllato (open/onToggle) o autonomo (defaultOpen).
export default function Section({ title, count, icon: Icon, badge, defaultOpen = false, open, onToggle, testid, id, children }) {
  const [internal, setInternal] = useState(defaultOpen);
  const controlled = open !== undefined;
  const isOpen = controlled ? open : internal;
  const toggle = () => (controlled ? onToggle?.(!isOpen) : setInternal((v) => !v));

  return (
    <section id={id} data-testid={testid} className="card-soft overflow-hidden scroll-mt-24">
      <button
        type="button"
        data-testid={`${testid}-toggle`}
        onClick={toggle}
        aria-expanded={isOpen}
        className="w-full min-h-[56px] px-5 py-4 flex items-center justify-between gap-3 text-left active:scale-[0.99] transition-transform duration-150"
      >
        <span className="flex items-center gap-3 min-w-0">
          {Icon && <Icon size={20} className="text-[#4a7c59] shrink-0" />}
          <span className="font-serif text-xl text-navy truncate">{title}</span>
          {badge}
          {typeof count === "number" && (
            <span data-testid={`${testid}-count`} className="text-xs font-bold text-white bg-[#4a7c59] rounded-full px-2.5 py-0.5 shrink-0">
              {count}
            </span>
          )}
        </span>
        <ChevronDown size={20} className={`text-muted-soft shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
      </button>
      {isOpen && (
        <div className="px-5 pb-5 pt-1" data-testid={`${testid}-content`}>
          {children}
        </div>
      )}
    </section>
  );
}
